import AutoSizedTextArea from 'components/inputs/AutoSizedTextArea';
import LabelWrap from 'components/inputs/LabelWrap';
import Modal, { modalContentClass } from 'components/Modal';
import { FC, useState } from 'react';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .${modalContentClass} {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 400px;

    textarea {
      width: auto;
    }
  }
`;

const Explanation = styled.p`
  margin: 0;
`;

interface ZakraHubReasonModalProps {
  companyName: string;
  onConfirm(reason: string): void;
  onClose(): void;
}

/**
 * Zäkra-hubbar är Zäkras egna anläggningar — ett ärende som har en hub som företag kan inte
 * faktureras. Den som sätter hubben som företag måste därför förklara varför. Förklaringen
 * sparas som en kommentar i ärendets händelselogg (backend gör samma kontroll och avvisar
 * sparningen om förklaringen saknas).
 */
const ZakraHubReasonModal: FC<ZakraHubReasonModalProps> = ({
  companyName,
  onConfirm,
  onClose,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Ange en förklaring');
      return;
    }
    onConfirm(reason.trim());
  };

  return (
    <StyledModal
      buttons={[
        {
          label: 'Spara',
          onClick: handleConfirm,
        },
        {
          label: 'Avbryt',
          onClick: onClose,
        },
      ]}
      closeOnOutsideClick={false}
      onClose={onClose}
      title="Zäkra-hub som företag"
    >
      <Explanation>
        {companyName} är en Zäkra-hub. Ärenden med en hub som företag kan inte
        faktureras — förklara varför hubben ska stå som företag på det här
        ärendet.
      </Explanation>
      <LabelWrap label="Anledning" errorLabel={error || undefined}>
        <AutoSizedTextArea
          value={reason}
          onChange={(e) => {
            setReason((e.target as HTMLTextAreaElement).value);
            setError('');
          }}
          placeholder="Ange varför en Zäkra-hub är satt som företag..."
        />
      </LabelWrap>
    </StyledModal>
  );
};

export default ZakraHubReasonModal;
